<template>
  <div style="padding-right: 84px">
    <div class="form-control" :class="{ 'has-error': errors.has('beaconIds') }">
      <label for="beacon" class="caption"> Beacon <span class="red--text">*</span> </label>
      <Multiselect
        ref="beacon"
        v-model="input.beacon_ids"
        v-validate="'required'"
        name="beacon"
        :options="beaconBranchOptions"
        :searchable="true"
        :allow-empty="true"
        select-label
        selected-label
        :multiple="true"
        label="name"
        track-by="beacon_id"
        data-vv-name="beaconIds"
        :data-vv-as="$t('beacon')"
        @search-change="handleSearchChange"
      >
        <template slot="beforeList">
          <div class="pl-2 py-2">
            <v-checkbox
              :value="isAllSelectedBeacon"
              :label="
                isAllSelectedBeacon || searchBranch !== null ? $t('deselect_all') : $t('Select All')
              "
              color="primary"
              hide-details
              class="mt-0"
              @change="handleCheckAllBeacon"
            ></v-checkbox>
          </div>
        </template>
      </Multiselect>
      <span v-show="errors.has('beaconIds')" class="text-error">{{
        errors.first('beaconIds')
      }}</span>
    </div>
    <div class="form-control mt-3" :class="{ 'has-error': errorMessage['beaconType'] !== '' }">
      <label for="beaconType" class="caption">
        {{ $t('beacon_type') }} <span class="red--text">*</span>
      </label>
      <v-radio-group
        ref="beaconType"
        v-model="input.beacon_type"
        v-validate="'required'"
        row
        name="beaconType"
        :data-vv-as="$t('beacon_type')"
        class="ma-0"
        hide-details
      >
        <v-radio label="Beacon Enter" value="beacon_enter" color="primary"></v-radio>
        <!-- <v-radio label="Beacon Banner" value="beacon_banner" color="primary"></v-radio> -->
      </v-radio-group>
      <span v-show="errorMessage['beaconType'] !== ''" class="text-error">
        {{ errors.first('beaconType') }}
      </span>
    </div>
    <div class="form-control mt-3" :class="{ 'has-error': errors.has('beaconGroupAudience') }">
      <label for="beaconGroupAudience" class="caption">{{ $t('group_audience') }} </label>
      <Multiselect
        ref="beaconGroupAudience"
        v-model="input.group_audience"
        name="beaconGroupAudience"
        :options="groupAudienceOptions"
        :searchable="false"
        :allow-empty="true"
        select-label
        selected-label
        :multiple="true"
        label="audience_name"
        track-by="id"
        data-vv-name="beaconGroupAudience"
        data-vv-as="กลุ่มเป้าหมาย"
      >
      </Multiselect>
      <span v-show="errors.has('beaconGroupAudience')" class="text-error">{{
        errors.first('beaconGroupAudience')
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  inject: ['$validator'],
  props: ['value'],
  data() {
    return {
      input: {
        beacon_ids: '',
        beacon_type: '',
        group_audience: ''
      },
      errorMessage: [],
      searchBranch: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    beaconBranchOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.beaconBranch

      if (tempData) {
        options = tempData.map((el) => {
          return { beacon_id: el.beacon_id, name: el.name }
        })
      }

      return options
    },
    groupAudienceOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.groupAudience

      if (tempData) {
        options = tempData.map((item) => {
          return { id: item.id, audience_name: item.audience_name }
        })
      }

      return options
    },
    isAllSelectedBeacon: function () {
      return this.input.beacon_ids.length === this.beaconBranchOptions.length
    }
  },
  watch: {
    input: {
      handler() {
        this.$emit('input', this.input)
      },
      deep: true
    },
    value: {
      handler() {
        this.input = this.value
      },
      deep: true
    }
  },
  mounted() {
    this.input = this.value
  },
  methods: {
    handleCheckAllBeacon() {
      if (this.searchBranch) {
        if (this.input.beacon_ids.length > 0) {
          this.searchBranch = null
          this.input.beacon_ids = []
        } else {
          const findBranch = this.beaconBranchOptions.filter((item) => {
            return item.name.includes(this.searchBranch)
          })
          this.input.beacon_ids = findBranch
        }
      } else {
        if (this.isAllSelectedBeacon) {
          this.input.beacon_ids = []
        } else {
          this.input.beacon_ids = this.beaconBranchOptions
        }
      }
    },
    handleSelectAllBeacon() {
      this.input.beacon_ids = this.beaconBranchOptions
    },
    handleDeselectAllBeacon() {
      this.input.beacon_ids = []
    },
    handleSearchChange(keyword) {
      if (keyword) {
        this.searchBranch = keyword
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentQuestionBeacon.vue